import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { Course } from '@lyceo/homi/shared/util-models';
import { PupilInformationPageActions } from '@lyceo/homi/pupils/data-access';
import { CallState, LoadingState } from '@lyceo/shared/util-loading';
import { CourseAPIActions } from './course.actions';
import { mapCourse } from './course.functions';

export const COURSE_FEATURE_KEY: string = 'course';

export interface CourseState extends EntityState<Course> {
  getCoursesCallState: CallState;
}

export const courseAdapter: EntityAdapter<Course> =
  createEntityAdapter<Course>();

export const initialCourseState: CourseState = courseAdapter.getInitialState({
  getCoursesCallState: LoadingState.INIT,
});

const reducer: ActionReducer<CourseState, Action> = createReducer(
  initialCourseState,
  on(
    PupilInformationPageActions.init,
    (state): CourseState => ({
      ...state,
      getCoursesCallState: LoadingState.LOADING,
    }),
  ),
  on(
    CourseAPIActions.getCoursesByWebsiteSuccess,
    (state, action): CourseState =>
      courseAdapter.upsertMany(
        action.courses.map((courseDto) => mapCourse(courseDto)),
        {
          ...state,
          getCoursesCallState: LoadingState.LOADED,
        },
      ),
  ),
  on(
    CourseAPIActions.getCoursesByWebsiteFailure,
    (state, { error }): CourseState => ({
      ...state,
      getCoursesCallState: { errorMsg: error.message },
    }),
  ),
);

export function courseReducer(
  state: CourseState | undefined,
  action: Action,
): CourseState {
  return reducer(state, action);
}
